import { CircularProgress, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import InputContainer from "../../../components/InputContainer";
import { allSpinner } from "../../../services/SpinnerWheelService";

const SpinnerFrom = ({ formik }) => {
  const [loading, setLoading] = useState(false);
  const [spinner, setSpinner] = useState("");

  const fetchSpinner = async () => {
    try {
      setLoading(true);
      const result = await allSpinner();
      setSpinner(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error in allSpinner:", error);
    }
  };

  useEffect(() => {
    fetchSpinner().catch((error) => {
      console.error("Error in fetchSpinner:", error);
    });
  }, []);
  return (
    <>
      <InputContainer title={"Spinner"} sx={{ my: 1 }}>
        <Select
          fullWidth
          size="small"
          variant="standard"
          id="entityId"
          name="entityId"
          value={formik.values.entityId}
          MenuProps={{ PaperProps: { sx: { maxHeight: "300px" } } }}
          renderValue={
            formik.values.entityId !== ""
              ? undefined
              : () => (
                  <Typography variant="subtitle1" color="text.disabled">
                    choose spinner
                  </Typography>
                )
          }
          displayEmpty
          onChange={(e) => {
            formik.handleChange(e);
          }}
          error={formik.touched.entityId && Boolean(formik.errors.entityId)}
          helperText={formik.touched.entityId && formik.errors.entityId}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              border: "2px solid #F6F6F6",
            },
            backgroundColor: "white",
          }}
        >
          {spinner?.length > 0 &&
            spinner?.map((e, i) => (
              <MenuItem key={i} value={e?.id}>
                {e?.name}
              </MenuItem>
            ))}
          {loading && (
            <MenuItem>
              <CircularProgress size={20} sx={{ margin: "auto" }} />
            </MenuItem>
          )}
        </Select>
      </InputContainer>
    </>
  );
};

export default SpinnerFrom;
